import Hero from "./components/Hero";
import TrustBadge from "./components/TrustBadge";
import MarqueeStrip from "./components/MarqueeStrip";
import Credibility from "./components/Credibility";
import Categories from "./components/Categories";
import WhyChoose from "./components/WhyChoose";
import ProductCatalog from "./components/ProductCatalog";
import EventsSection from "./components/EventsSection";
import ForCompanies from "./components/ForCompanies";
import QualityTimeline from "./components/QualityTimeline";
import Supermarkets from "./components/Supermarkets";
import Testimonials from "./components/Testimonials";
import InstagramFeed from "./components/InstagramFeed";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import OrganicDivider from "@/components/base/OrganicDivider";

export default function Home() {
  return (
    <>
      <Hero />

      {/* Trust Badge — certification seal right below Hero */}
      <TrustBadge />

      {/* Marquee strip — key brand messages */}
      <MarqueeStrip />

      {/* TrustBadge → Credibility: smooth transition */}
      <div className="relative -mt-1">
        <OrganicDivider variant="wave" fill="background-50" />
      </div>
      <Credibility />

      {/* Credibility → Categories */}
      <OrganicDivider variant="wave-invert" fill="background-100" />
      <Categories />

      <WhyChoose />

      {/* WhyChoose → ProductCatalog */}
      <OrganicDivider variant="wave-invert" fill="background-100" />
      <ProductCatalog />

      {/* ProductCatalog → EventsSection */}
      <OrganicDivider variant="wave" fill="background-50" />
      <EventsSection />

      {/* EventsSection → ForCompanies */}
      <OrganicDivider variant="wave-invert" fill="background-100" />
      <ForCompanies />

      {/* ForCompanies → QualityTimeline */}
      <OrganicDivider variant="wave" fill="background-50" />
      <QualityTimeline />

      {/* QualityTimeline → Supermarkets */}
      <OrganicDivider variant="wave-invert" fill="background-100" />
      <Supermarkets />

      <Testimonials />
      <InstagramFeed />

      {/* Instagram → FAQ */}
      <OrganicDivider variant="wave-invert" fill="background-50" />
      <FAQ />

      {/* FAQ → Contact */}
      <OrganicDivider variant="wave" fill="background-100" />
      <Contact />
    </>
  );
}